document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.hover-video');

  videos.forEach(video => {
    const productCard = video.closest('.product-card');
    let hideTimeout;

    // Set initial state
    video.classList.remove('visible');
    video.style.display = 'none';

    productCard.addEventListener('mouseenter', () => {
      if (video.getAttribute('preload') === 'none') {
        video.setAttribute('preload', 'auto');
        video.load();
      }

      video.style.display = 'block';
      void video.offsetWidth; // force reflow for transition
      video.classList.add('visible');
      video.play().catch(() => {});
      clearTimeout(hideTimeout);
    });

    productCard.addEventListener('mouseleave', () => {
      video.classList.remove('visible');
      hideTimeout = setTimeout(() => {
        video.pause();
        video.style.display = 'none';
      }, 300);
    });
  });
});





document.addEventListener('DOMContentLoaded', function() {
  // Setup
  const categoryTabs = document.querySelectorAll('.category-section .tab');
  const tagTabs = document.querySelectorAll('.tags-section .tab');
  const productCards = document.querySelectorAll('.product-card');

  // State
  let selectedCategories = new Set();
  let selectedTags = new Set();

  // Parse URL on load
  const params = new URLSearchParams(window.location.search);
  const initCategories = params.get('categories')?.split(',').filter(Boolean) || [];
  const initTags = params.get('tags')?.split(',').filter(Boolean) || [];
  selectedCategories = new Set(initCategories);
  selectedTags = new Set(initTags);

  // Init
  updateTabsFromState();
  filterProducts();

  // Event Listeners
  categoryTabs.forEach(tab => tab.addEventListener('click', () => handleTabClick(tab, 'category')));
  tagTabs.forEach(tab => tab.addEventListener('click', () => handleTabClick(tab, 'tag')));

  function handleTabClick(tab, type) {
  const value = type === 'category' ? tab.dataset.category : tab.dataset.tab;
  const isAll = value === 'all';
  const set = type === 'category' ? selectedCategories : selectedTags;
  const isPillGroup = tab.closest('.pill');

  if (type === 'category') {
    if (isAll) {
      set.clear();
    } else {
      if (set.has(value)) {
        set.delete(value);
      } else {
        set.add(value);
      }
    }
  } 
  else {
    if (isPillGroup) {
      // Scoped pill group logic
      const groupTabs = Array.from(isPillGroup.querySelectorAll('.tab'));
      const groupValues = groupTabs.map(t => t.dataset.tab);

      const isAlreadySelected = set.has(value);

      // Clear only the values from this pill group
      groupValues.forEach(val => set.delete(val));

      // If it wasn't already selected, toggle it on
      if (!isAll && !isAlreadySelected) {
        set.add(value);
      }
    } else {
      // Default multi-toggle behavior
      if (isAll) {
        set.clear();
      } else {
        if (set.has(value)) {
          set.delete(value);
        } else {
          set.add(value);
        }
      }
    }
  }

  // Handle re-activating the "All" tab when none selected
  if (set.size === 0) {
    document.querySelector(`.${type === 'category' ? 'category-section' : 'tags-section'} .tab[data-${type === 'category' ? 'category' : 'tab'}='all']`)?.classList.add('active');
  }

  updateURL();
  updateTabsFromState();
  filterProducts();
}


  function updateURL() {
    const query = new URLSearchParams();
    if (selectedCategories.size > 0) query.set('categories', [...selectedCategories].join(','));
    if (selectedTags.size > 0) query.set('tags', [...selectedTags].join(','));
    const newUrl = `${window.location.pathname}?${query.toString()}`;
    history.replaceState(null, '', newUrl);
  }

  function updateTabsFromState() {
    [...categoryTabs, ...tagTabs].forEach(tab => tab.classList.remove('active'));

    if (selectedCategories.size === 0) {
      document.querySelector('.category-section .tab[data-category="all"]')?.classList.add('active');
    } else {
      selectedCategories.forEach(cat => {
        document.querySelector(`.category-section .tab[data-category='${cat}']`)?.classList.add('active');
      });
    }

    if (selectedTags.size === 0) {
      document.querySelector('.tags-section .tab[data-tab="all"]')?.classList.add('active');
    } else {
      selectedTags.forEach(tag => {
        document.querySelector(`.tags-section .tab[data-tab='${tag}']`)?.classList.add('active');
      });
    }
  }
function filterProducts() {
  const allHeadingBlocks = document.querySelectorAll('.heading-block');
  const allCards = [...productCards];

  let currentHeading = null;
  const headingToCards = new Map();

  // Group product cards under their preceding heading
  document.querySelectorAll('.heading-block, .product-card').forEach(el => {
    if (el.classList.contains('heading-block')) {
      currentHeading = el;
      headingToCards.set(currentHeading, []);
    } else if (el.classList.contains('product-card') && currentHeading) {
      headingToCards.get(currentHeading).push(el);
    }
  });

  // Track headings that should be shown
  const visibleHeadings = new Set();

  allCards.forEach(card => {
    const categorySpans = card.querySelectorAll('.product-category');
    const cardCategories = [...categorySpans].map(span => span.dataset.category?.toLowerCase());

    const tagElements = card.querySelectorAll('.product-tag');
    const tags = [...tagElements].map(el => el.dataset.tag?.toLowerCase());

    const matchCategory =
      selectedCategories.size === 0 ||
      [...selectedCategories].every(cat => cardCategories.includes(cat));

    const matchTags =
      selectedTags.size === 0 ||
      [...selectedTags].every(tag => tags.includes(tag));

    const show = matchCategory && matchTags;
    card.classList.toggle('hidden', !show);

    if (show) {
      // Find the heading this card belongs to
      for (const [heading, cards] of headingToCards.entries()) {
        if (cards.includes(card)) {
          visibleHeadings.add(heading);
          break;
        }
      }
    }
  });

  // Show/hide each heading based on whether any of its cards are visible
  for (const [heading, cards] of headingToCards.entries()) {
    const anyVisible = cards.some(card => !card.classList.contains('hidden'));
    heading.classList.toggle('hidden', !anyVisible);
  }
}




});
